(() => {
  function bindPairings(root = document) {
    root.querySelectorAll('.ff-gifts__form').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const button = form.querySelector('button');
      const status = form.querySelector('[role="status"]');
      button.hidden = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled) return;
        const label = button.textContent;
        button.disabled = true;
        button.textContent = form.dataset.loading;
        status.textContent = '';
        const data = new FormData(form);
        const items = [0, 1].map((index) => ({id: Number(data.get(`items[${index}][id]`)), quantity: 1}));
        try {
          const response = await fetch(`${form.action}.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
          if (!response.ok) throw new Error('pairing_add_failed');
          window.location.assign(form.dataset.cartUrl);
        } catch {
          status.textContent = form.dataset.error;
          button.disabled = false;
          button.textContent = label;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindPairings());
  else bindPairings();
  document.addEventListener('shopify:section:load', (event) => bindPairings(event.target));
})();
